module.exports = __webpack_public_path__ + "img/cover_image.22173b03.png";